import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const ProductsPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<string>('');

  const categories = [
    { id: 'all', label: 'All Products', icon: 'ri-apps-line' },
    { id: 'microelectronics', label: 'Microelectronics', icon: 'ri-cpu-line' },
    { id: 'sensors', label: 'Sensors & Modules', icon: 'ri-sensor-line' },
    { id: 'cables', label: 'Cables & Connectors', icon: 'ri-plug-line' },
    { id: 'power', label: 'Power Supplies', icon: 'ri-battery-charge-line' },
    { id: 'passive', label: 'Passive Components', icon: 'ri-circuit-line' },
    { id: 'spare-parts', label: 'Spare Parts', icon: 'ri-tools-line' },
  ];

  const products = [
    {
      id: 1,
      name: 'STM32 Microcontroller Series',
      category: 'microelectronics',
      description: 'High-performance ARM Cortex-M microcontrollers for embedded applications',
      specs: '32-bit, 72MHz, 64KB Flash',
      price: 'Request Quote',
      image: 'https://public.readdy.ai/ai/img_res/fbd8505a2ca64df592449ba3dc2eb123.jpg',
    },
    {
      id: 2,
      name: 'Temperature Sensor Module DHT22',
      category: 'sensors',
      description: 'Digital temperature and humidity sensor with high accuracy',
      specs: 'Range: -40 to 80°C, ±0.5°C accuracy',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=digital%20temperature%20humidity%20sensor%20module%20with%20pins%20and%20circuit%20board%20white%20plastic%20housing%20professional%20product%20photo%20on%20clean%20background%20technical%20component%20with%20clear%20details&width=500&height=400&seq=product-002&orientation=landscape',
    },
    {
      id: 3,
      name: 'USB Type-C Cable Assembly',
      category: 'cables',
      description: 'High-speed USB 3.1 Type-C cable with power delivery support',
      specs: '1m length, 100W PD, 10Gbps data',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=usb%20type%20c%20cable%20connector%20close%20up%20black%20cable%20with%20metallic%20connector%20professional%20product%20photography%20on%20white%20background%20technical%20precision%20and%20quality%20construction&width=500&height=400&seq=product-003&orientation=landscape',
    },
    {
      id: 4,
      name: 'Switching Power Supply 24V 10A',
      category: 'power',
      description: 'Industrial-grade switching power supply with overload protection',
      specs: '240W output, 85-264VAC input',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=industrial%20switching%20power%20supply%20unit%20metal%20housing%20with%20ventilation%20slots%20and%20terminals%20professional%20product%20photo%20on%20clean%20background%20technical%20equipment%20with%20specifications%20label&width=500&height=400&seq=product-004&orientation=landscape',
    },
    {
      id: 5,
      name: 'Ceramic Capacitor Kit 0805 SMD',
      category: 'passive',
      description: 'Assorted ceramic capacitors for surface mount applications',
      specs: '50V, 1pF-10µF, ±5% tolerance',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=surface%20mount%20ceramic%20capacitors%20tiny%20electronic%20components%20arranged%20on%20white%20surface%20professional%20macro%20photography%20showing%20technical%20details%20and%20markings%20precision%20components&width=500&height=400&seq=product-005&orientation=landscape',
    },
    {
      id: 6,
      name: 'Arduino Compatible Development Board',
      category: 'microelectronics',
      description: 'ATmega328P-based development board for prototyping',
      specs: '16MHz, 32KB Flash, 14 digital I/O',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=arduino%20development%20board%20blue%20pcb%20with%20microcontroller%20and%20pins%20professional%20product%20photography%20on%20white%20background%20electronic%20prototyping%20board%20with%20clear%20component%20layout&width=500&height=400&seq=product-006&orientation=landscape',
    },
    {
      id: 7,
      name: 'Ultrasonic Distance Sensor HC-SR04',
      category: 'sensors',
      description: 'Non-contact distance measurement sensor module',
      specs: 'Range: 2cm-400cm, 15° angle',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=ultrasonic%20distance%20sensor%20module%20with%20two%20circular%20transducers%20green%20pcb%20professional%20product%20photo%20on%20white%20background%20technical%20sensor%20component%20with%20pins&width=500&height=400&seq=product-007&orientation=landscape',
    },
    {
      id: 8,
      name: 'RJ45 Ethernet Connector',
      category: 'cables',
      description: 'Shielded RJ45 connector for Cat6 network cables',
      specs: '8P8C, gold-plated contacts',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=rj45%20ethernet%20connector%20transparent%20plastic%20housing%20with%20gold%20contacts%20professional%20product%20photography%20on%20white%20background%20network%20cable%20connector%20technical%20detail&width=500&height=400&seq=product-008&orientation=landscape',
    },
    {
      id: 9,
      name: 'LED Driver Module 350mA',
      category: 'power',
      description: 'Constant current LED driver for high-power LEDs',
      specs: '1-10W, 85-265VAC input',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=led%20driver%20circuit%20board%20module%20with%20electronic%20components%20professional%20product%20photo%20on%20white%20background%20power%20supply%20module%20with%20technical%20specifications&width=500&height=400&seq=product-009&orientation=landscape',
    },
    {
      id: 10,
      name: 'Resistor Kit 1/4W Metal Film',
      category: 'passive',
      description: 'Assorted metal film resistors with color coding',
      specs: '1Ω-1MΩ, ±1% tolerance, 600pcs',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=metal%20film%20resistors%20with%20color%20bands%20electronic%20components%20arranged%20on%20white%20surface%20professional%20product%20photography%20showing%20technical%20details%20precision%20passive%20components&width=500&height=400&seq=product-010&orientation=landscape',
    },
    {
      id: 11,
      name: 'Industrial Motor Bearing Set',
      category: 'spare-parts',
      description: 'Precision ball bearings for industrial motors',
      specs: '6205-2RS, sealed, steel construction',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=industrial%20ball%20bearing%20metallic%20precision%20component%20with%20inner%20and%20outer%20rings%20professional%20product%20photo%20on%20white%20background%20mechanical%20spare%20part%20with%20technical%20quality&width=500&height=400&seq=product-011&orientation=landscape',
    },
    {
      id: 12,
      name: 'Relay Module 5V 10A',
      category: 'microelectronics',
      description: 'Electromechanical relay module with optocoupler isolation',
      specs: '5VDC coil, 10A 250VAC contacts',
      price: 'Request Quote',
      image: 'https://readdy.ai/api/search-image?query=relay%20module%20circuit%20board%20with%20blue%20relay%20component%20professional%20product%20photography%20on%20white%20background%20electronic%20switching%20module%20with%20clear%20technical%20details&width=500&height=400&seq=product-012&orientation=landscape',
    },
  ];

  const filteredProducts = selectedCategory === 'all' 
    ? products 
    : products.filter(p => p.category === selectedCategory);

  const handleInquiry = (productName: string) => {
    setSelectedProduct(productName);
    setShowInquiryModal(true);
  };

  const handleSubmitInquiry = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    fetch('https://readdy.ai/api/form/d4i0k4musuhg53kqajng', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams(formData as any).toString(),
    })
      .then(() => {
        alert('Inquiry submitted successfully! We will contact you soon.');
        setShowInquiryModal(false);
        form.reset();
      })
      .catch(() => {
        alert('Failed to submit inquiry. Please try again.');
      });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <section className="relative pt-32 pb-24 px-6 lg:px-12 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6 border border-white/20">
            <i className="ri-shopping-bag-3-line text-white"></i>
            <span className="text-sm text-white font-semibold">Product Catalog</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Quality <strong>Electronic Components</strong>
          </h1>

          <p className="text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto">
            Browse our extensive catalog of electronic components, sensors, modules, and technical spare parts.
          </p>
        </div>
      </section>

      <section className="py-12 px-6 lg:px-12 bg-white border-b border-slate-200 sticky top-0 z-40 backdrop-blur-md bg-white/95">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center space-x-4 overflow-x-auto pb-2">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-300 whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-gradient-to-r from-blue-600 to-cyan-500 text-white shadow-lg'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                }`}
              >
                <i className={`${category.icon} text-lg`}></i>
                <span>{category.label}</span>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 px-6 lg:px-12 bg-slate-50" data-product-shop>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredProducts.map((product) => (
              <div
                key={product.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <div className="relative h-64 overflow-hidden bg-slate-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top transform group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 px-3 py-1 bg-blue-600 text-white text-sm font-semibold rounded-full">
                    In Stock
                  </div>
                </div>

                <div className="p-6">
                  <div className="text-sm text-blue-600 font-medium mb-2">
                    {categories.find(c => c.id === product.category)?.label}
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                    {product.name}
                  </h3>
                  <p className="text-slate-600 mb-4 leading-relaxed">{product.description}</p>
                  
                  <div className="bg-slate-50 rounded-lg p-3 mb-4">
                    <div className="text-sm text-slate-500 mb-1">Specifications:</div>
                    <div className="text-sm text-slate-700 font-medium">{product.specs}</div>
                  </div>

                  <div className="flex items-center justify-between">
                    <div className="text-lg font-bold text-blue-600">{product.price}</div>
                    <button
                      onClick={() => handleInquiry(product.name)}
                      className="px-6 py-2 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-sm font-semibold rounded-lg hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap"
                    >
                      <i className="ri-mail-line mr-2"></i>
                      Inquire
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {showInquiryModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="text-3xl font-bold text-slate-900">Product Inquiry</h2>
                <button
                  onClick={() => setShowInquiryModal(false)}
                  className="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-slate-600 transition-colors duration-300"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>

              <form id="product-inquiry-form" data-readdy-form onSubmit={handleSubmitInquiry}>
                <input type="hidden" name="product" value={selectedProduct} />

                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Product
                    </label>
                    <input
                      type="text"
                      value={selectedProduct}
                      disabled
                      className="w-full px-4 py-3 bg-slate-100 border border-slate-300 rounded-lg text-slate-700"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Your Name *
                    </label>
                    <input
                      type="text"
                      name="name"
                      required
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-sm"
                      placeholder="Enter your full name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      name="email"
                      required
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-sm"
                      placeholder="your@email.com"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Phone Number
                    </label>
                    <input
                      type="tel"
                      name="phone"
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-sm"
                      placeholder="+380 00 000 0000"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Company Name
                    </label>
                    <input
                      type="text"
                      name="company"
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-sm"
                      placeholder="Your company name"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Quantity Needed
                    </label>
                    <input
                      type="number"
                      name="quantity"
                      min="1"
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 text-sm"
                      placeholder="Enter quantity"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-slate-700 mb-2">
                      Additional Information
                    </label>
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-300 resize-none text-sm"
                      placeholder="Any specific requirements or questions... (max 500 characters)"
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white text-lg font-bold rounded-lg hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-send-plane-fill mr-2"></i>
                    Submit Inquiry
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ProductsPage;
